import { ApplicationRouteURL } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { InboxService } from './../models/inbox.service';
import { InboxViewComponent } from './inbox-view.component';
import { InboxListComponent } from './inbox-list.component';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'wego-inbox',
  template: require('../views/inbox.component.html'),
  providers: [InboxService]
})
export class InboxComponent implements OnInit {
  private urlDefaultPage: string;
  private notificationInboxHashID: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
  }

  private ShowNotification($event: any) {
    this.notificationInboxHashID = $event.NotificationInboxHashID;
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/inbox/components/inbox.component.ts